export default "__VITE_ASSET__CFYpwdfw__"